import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getBookingById } from "../../api/bookingsApi";
import PageLoader from "../../components/pageLoader";
import Toast from "../../components/toast";
import ToastContainer from "../../components/toastContainer";
import MainInfoTab from './tabs/DetailTab';
import TravelTab from "./tabs/TravelTab";
import TechnicalTab from "./tabs/TechnicalTab";
import DocumentsTab from './tabs/DocumentsTab';

const TABS = [
  { key: "main_info", label: "Main Info" },
  { key: "accommodation", label: "Travel & Accommodation" },
  { key: "technical", label: "Technical" },
  { key: "documents", label: "Documents" },
];

const BookingDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("main_info");
  const [toast, setToast] = useState(null);

  const fetchBooking = async () => {
    try {
      setLoading(true);
      const data = await getBookingById(id);
      setBooking(data);
    } catch (err) {
      setToast({
        type: "error",
        message: err?.response?.data?.detail || "Failed to load the booking info",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBooking();
  }, [id]);

  if (loading) return <PageLoader />;

  if (!booking) {
    return (
      <div className="p-6 text-slate-400">
        No booking info found
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-slate-400 hover:text-white"
        >
          ← Back to Bookings
        </button>
      </div>

      {/* Tabs */}
      <div className="border-b border-white/10 flex gap-6 overflow-x-auto">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`pb-3 text-sm font-medium transition whitespace-nowrap
              ${
                activeTab === tab.key
                  ? "text-pink-500 border-b-2 border-pink-500"
                  : "text-slate-400 hover:text-white"
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "main_info" && <MainInfoTab booking={booking} />}
        {activeTab === "accommodation" && <TravelTab booking={booking} />}
        {activeTab === "technical" && <TechnicalTab booking={booking} />}
        {activeTab === "documents" && <DocumentsTab booking={booking} />}
      </div>

      <ToastContainer>
        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </ToastContainer>
    </div>
  );
};

export default BookingDetailsPage;
